import React, { useMemo } from 'react'
import { When } from 'react-if'
import { Button, LinkButton } from '@/atoms/Button'
import { HeadingLG } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface AmbassadorActionButtonProps {
  href?: string | null
  heading?: string | null
  onClick: () => void
  backgroundImageUrl?: string | null
  openingBehavior?: string | null
}
export const AmbassadorActionButton: React.FC<AmbassadorActionButtonProps> = ({
  href,
  heading,
  onClick,
  backgroundImageUrl,
  openingBehavior,
}) => {
  const ctaTarget = useMemo(() => {
    if (openingBehavior?.toLowerCase() === 'new tab') {
      return '_blank'
    } else if (openingBehavior?.toLowerCase() === 'same tab') {
      return '_self'
    } else {
      return '_blank'
    }
  }, [openingBehavior])

  return (
    <div className="flex flex-col gap-6 text-left">
      <When condition={href}>
        <LinkButton
          variant="core-gray-800"
          href={href as string}
          onClick={onClick}
          target={ctaTarget ?? '_blank'}
          style={{
            backgroundImage: `url(${getCloudinaryImageUrl({ path: backgroundImageUrl ?? '' })})`,
          }}
          className="no-repeat flex min-h-[180px] cursor-pointer items-end justify-start rounded-2xl border-0 bg-cover bg-center p-4 bg-blend-normal backdrop-opacity-0 transition-all duration-300 ease-in-out sm:min-h-[200px] lg:min-h-[220px] lg:bg-blend-overlay lg:hover:bg-blend-normal lg:hover:backdrop-opacity-20 2xl:min-h-[255px]"
        >
          <HeadingLG className="photon-heading-sm md:photon-heading-md lg:photon-heading-lg">{heading}</HeadingLG>
        </LinkButton>
      </When>
      <When condition={!href}>
        <Button
          variant="core-gray-800"
          onClick={onClick}
          style={{ backgroundImage: `url(${getCloudinaryImageUrl({ path: backgroundImageUrl ?? '' })})` }}
          className="no-repeat flex min-h-[180px] cursor-pointer items-end justify-start rounded-2xl border-0 bg-cover bg-center p-4 bg-blend-normal backdrop-opacity-0 transition-all duration-300 ease-in-out sm:min-h-[200px] lg:min-h-[220px] lg:bg-blend-overlay lg:hover:bg-blend-normal lg:hover:backdrop-opacity-20 2xl:min-h-[255px]"
        >
          <HeadingLG className="photon-heading-sm md:photon-heading-md lg:photon-heading-lg">{heading}</HeadingLG>
        </Button>
      </When>
    </div>
  )
}
